export const faceSwapeCameraOptions = {
    photography: {
      cameraType: {
        label: '相机类型',
        options: {
          fullFrameDslr: '全幅单反相机',
          apsC: 'APS-C 相机',
          mirrorless: '无反光镜相机',
          mediumFormat: '中画幅相机',
          pointAndShoot: '傻瓜相机',
          phone: '手机相机'
        }
      },
      lensType: {
        label: '镜头类型',
        options: {
          standard: '标准镜头 (50mm f/1.8)',
          wideAngle: '广角镜头 (35mm, 24mm)',
          mediumTelephoto: '中长焦镜头 (85mm, 105mm)',
          telephoto: '长焦镜头 (200mm, 300mm)',
          macro: '微距镜头',
          fisheye: '鱼眼镜头',
          zoom: '变焦镜头 (24-70mm, 70-200mm)',
          prime: '定焦镜头 (35mm, 50mm, 85mm)',
          largeAperture: '大光圈镜头 (f/1.2, f/1.4)'
        }
      },
      focalLength: {
        label: '焦距',
        options: {
          ultraWide: '超广角 (10mm-24mm)',
          wide: '广角 (35mm, 50mm)',
          standard: '标准 (85mm, 105mm)',
          telephoto: '长焦 (200mm, 300mm)',
          superTelephoto: '超长焦 (400mm, 600mm)'
        }
      },
      aperture: {
        label: '光圈',
        options: {
          large: '大光圈 (f/1.2, f/1.4)',
          medium: '中光圈 (f/2.8, f/3.5)',
          small: '小光圈 (f/8, f/11)'
        }
      },
      shutterSpeed: {
        label: '快门速度',
        options: {
          fast: '快速快门 (1/1000s, 1/500s)',
          medium: '中速快门 (1/250s, 1/125s)',
          slow: '慢速快门 (1/60s, 1/30s)'
        }
      },
      iso: {
        label: 'ISO',
        options: {
          low: '低 ISO (100-400)',
          medium: '中 ISO (800-1600)',
          high: '高 ISO (3200-6400)'
        }
      },
      whiteBalance: {
        label: '白平衡',
        options: {
          auto: '自动',
          daylight: '日光',
          cloudy: '阴天',
          tungsten: '钨丝灯',
          fluorescent: '荧光灯',
          custom: '自定义'
        }
      },
      focusMode: {
        label: '对焦模式',
        options: {
          singlePoint: '单点对焦',
          zone: '区域对焦',
          auto: '自动对焦',
          faceDetection: '人脸检测对焦',
          tracking: '追踪对焦',
          manual: '手动对焦'
        }
      },
      exposureMode: {
        label: '曝光模式',
        options: {
          auto: '自动曝光',
          shutterPriority: '快门优先',
          aperturePriority: '光圈优先',
          manual: '手动曝光',
          compensation: '曝光补偿'
        }
      },
      shootingMode: {
        label: '拍摄模式',
        options: {
          single: '单张拍摄',
          burst: '连拍模式',
          timeLapse: '延时摄影',
          slowMotion: '慢动作'
        }
      },
      shootingAngle: {
        label: '拍摄角度',
        options: {
          high: '俯视角度 (向下看)',
          low: '仰视角度 (向上看)',
          front: '正面视角',
          side: '侧面视角',
          fortyFive: '45度角'
        }
      },
      pose: {
        label: '姿势',
        options: {
          power: '力量姿势',
          walking: '行走姿势',
          sCurve: 'S曲线姿势',
          sitting: '坐姿',
          leaning: '倚靠姿势',
          headshot: '头像姿势',
          handOnHip: '叉腰姿势',
          candidLaugh: '自然笑容姿势',
          highFashion: '高级时尚姿势'
        }
      }
    }
  };
